<app-banner [loading]="loading" [info]="true" [heading]="'Maintenance'"
  [subHeading]="'Set the maintenance message to be displayed to registrants'">
  <div class="toolbar-content">
    @if (!layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(true)" aria-label="Maximise"
        class="btn btn-back">
        <i class="fa fa-window-maximize"></i>
        <span>maximise</span>
      </button>
    }
    @if (layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(false)" aria-label="Maximise"
        class="btn btn-back">
        <i class="fa fa-window-restore"></i>
        <span>restore</span>
      </button>
    }
  </div>
</app-banner>

<div class="content spread">

  <!-- Banner message -->
  @if (data) {
    <div class="important notification-banner" style="margin-top: 15px;margin-bottom: 15px;">
      <div class="row">
        <div class="col-md-12">
          <h3 style="color:white;margin-bottom:1em;">{{ model.messageTitle }}</h3>
          @if ((model.isMessageWithLink && isLinkTextSelected) || !model.isMessageWithLink) {
            <p [innerHTML]="bannerMessage"></p>
          }
        </div>
      </div>
    </div>
  } @else {
    <div class="form-group">
      <div class="readonly messgeStatus">
        <i class="fa fa-clock-o"></i>
        <b>
          Currently no active message
        </b>
      </div>
    </div>
  }

  <div class="row justify-content-between">
    <div class="col-md-8">
      <div class="form-group">
      </div>
    </div>
  </div>


  <div class="row fadein">
    <div class="col-sm-6 right-col">
      <section>
        <form #maintenanceForm="ngForm">
          <div class="section-body">

            <h3 class="header">
              Message
            </h3>

            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="warningHeader">Title</label>
                  <input type="text" class="form-control" id="messageHeader"
                    aria-describedby="MessageTitle" placeholder="Message title"
                    [(ngModel)]='model.messageTitle' name="messageTitle" required>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="maintenanceMessageType" class="mr-3">Is there a hyperlink in the message?</label>
                    <mat-radio-group id="maintenanceMessageType" name="isMessageWithLink" [(ngModel)]="model.isMessageWithLink" aria-describedby="maintenanceMessageType">
                      <mat-radio-button [value]="true">Yes</mat-radio-button>
                      <mat-radio-button [value]="false">No</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>

              <app-collapsible [trigger]="model.isMessageWithLink !== null">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">

                      @if (model.isMessageWithLink) {
                        <div class="important">
                          After adding the message below, please select the text you would like to link.
                        </div>
                      }
                      @if (model.isMessageWithLink) {
                        <br >
                      }
                      <label>Message</label>
                      <textarea #textbox [(ngModel)]='model.messageBody' required class="form-control" rows="2" aria-describedby="message"
                      name="messageBody" (select)="onTextSelect()" (blur)="onBlurTextArea()"></textarea>
                    </div>
                  </div>
                </div>

                @if (model.isMessageWithLink) {
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group pointer-event-none">
                        <label for="linkText">Selected text to link</label>
                        <input type="text" class="form-control gray-background" id="linkText"
                          aria-describedby="LinkText" [(ngModel)]='model.linkText' name="linkText" required>
                        </div>
                      </div>
                    </div>
                  }

                  @if (model.isMessageWithLink) {
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="hyperlink">Hyperlink</label>
                          <input type="text" class="form-control" id="hyperlink"
                            aria-describedby="hyperlinkInTheMessage" [(ngModel)]='model.hyperlink' name="hyperlink" (blur)="onAddingHyperLink()" required>
                          </div>
                        </div>
                      </div>
                    }

                    <div class="row display-none">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label for="finalMessage">The message would look like below</label>
                          <input id="finalMessage"
                            aria-describedby="finalMessage" name="messageWithLink" [(ngModel)]="model.messageWithLink">
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <mat-slide-toggle [(ngModel)]="model.showLogin" color="primary"
                            name="showLogin">
                            <b>
                              Should show login
                            </b>
                          </mat-slide-toggle>
                        </div>
                        <div class="col-md-6">
                          <mat-slide-toggle
                            [(ngModel)]="model.messageActive" name="messageActive"
                            [disabled]="maintenanceForm.invalid"
                            >

                            <b>
                              {{ (model.messageActive) ? ' Deactivate message ' : ' Activate message ' }}
                            </b>
                          </mat-slide-toggle>
                        </div>
                      </div>


                      <br>

                        <div class="row">
                          <div class="col-sm">
                            <button class="btn btn-block btn-primary" (click)="clear(maintenanceForm)">Clear
                            message</button>
                          </div>
                          <div class="col-sm">
                            <button class="btn btn-block btn-primary"
                              [disabled]="maintenanceForm.invalid || (model.isMessageWithLink && (!isLinkTextSelected || !model.hyperlink))"
                              (click)="userAcceptsResponsibility(maintenanceForm)">
                              Save form
                            </button>
                          </div>
                        </div>
                      </app-collapsible>

                    </div>
                  </form>

                </section>



              </div>
            </div>
          </div>